import {createStore} from "redux";
import {
    LOGIN,
    LOGOUT,
    TOGGLE_ASIDE,
    TOGGLE_DARK,
    UPDATE_INFO,
    SET_TITLE,
    SET_BREADCRUMBS,
    SET_DEPARTMENT,
    SET_DEPARTMENTS, SET_CREATE_BUTTON, SET_SEARCH_HANDLER, SET_SEARCH_STRING, SET_IS_MOBILE, SET_HEAD_BTNS
} from "../actions/types";
import {userService} from "../services/UserService";

const initialState = {
    auth: { loggedIn: false, userData: null, logout: false },
    asideStatus: window.innerWidth <= 768 ? 'close_icon' : '',
    darkStatus: '',
    pageTitle: '',
    breadcrumbs: [],
    currentDepartment: userService.GetCurrentDepartment(),
    departments: [],
    createButton: null,
    searchHandler: null,
    searchString: null,
    isMobile: window.innerWidth <= 768,
    eventStateDate: null,
    headBtns: []
}

export function userReducer(state = initialState, action) {
    switch (action.type) {
        case LOGIN:
            return { ...state, auth: {userData: action.userData, loggedIn: true, logout: false }}
        case UPDATE_INFO:
            return { ...state, auth: {userData: action.userData, loggedIn: true, logout: false }}
        case LOGOUT:
            return { ...state, auth: {userData: null, loggedIn: false, logout: true}}
        case TOGGLE_ASIDE:
            return { ...state, asideStatus: action.asideStatus}
        case TOGGLE_DARK:
            return { ...state, darkStatus: action.darkStatus}
        case SET_TITLE:
            return { ...state, pageTitle: action.pageTitle}
        case SET_BREADCRUMBS:
            return { ...state, breadcrumbs: action.breadcrumbs}
        case SET_DEPARTMENT:
            return { ...state, currentDepartment: action.currentDepartment}
        case SET_DEPARTMENTS:
            return { ...state, departments: action.data}
        case SET_CREATE_BUTTON:
            return  {...state, createButton: action.createButton}
        case SET_SEARCH_HANDLER:
            return  {...state, searchHandler: action.searchHandler}
        case SET_SEARCH_STRING:
            return  {...state, searchString: action.searchString}
        case SET_IS_MOBILE:
            return  {...state, isMobile: action.status}
        case SET_HEAD_BTNS:
            return  {...state, headBtns: action.headBtns}
        case 'events_state_date':
            return  {...state, eventsStateDate: action.eventStateDate}
        default:
            return state
    }
}

let store = createStore(userReducer)



export default store

